import { useState, useEffect } from 'react';
import { atom, useRecoilState } from 'recoil';
import { recoilPersist } from 'recoil-persist';

const { persistAtom } = recoilPersist();

export type AppState = {
  isAccessible: boolean;
};

export const appState = atom<AppState>({
  key: 'accessible',
  default: { isAccessible: false },
  effects_UNSTABLE: [persistAtom],
});

export const useAppSSR = () => {
  const [isInitial, setIsInitial] = useState(true);
  const [value, setValue] = useRecoilState(appState);

  useEffect(() => {
    setIsInitial(false);
    setValue({ isAccessible: !window.ENV.PASSWORD });
  }, [setValue]);

  return [isInitial ? { isAccessible: false } : value, setValue] as const;
};
